import {
    findAddressByParentId
} from "@/api/http";
export const addressMix = {
    data() {
        return {
            option11: [],
            option12: [],
            option13: [],
            option14: [],
        }
    },
    methods: {
        dwshiValue(value) {
            this.baseForm.cityId = value;

            let obj = {};
            obj = this.option12.find(item => {
                //这里的ClaOptions就是上面遍历的数据源
                return item.id === value; //筛选出匹配数据，这里的value是你遍历数组每一项的value，如果没有对后台返回的数据做处理，一般为id
            });
            this.baseForm.cityLabel = obj.addressName;
        },
        dwquValue(value) {
            //   console.log(value);
            this.baseForm.areaId = value;
            let obj = {};
            obj = this.option13.find(item => {
                //这里的ClaOptions就是上面遍历的数据源
                return item.id === value; //筛选出匹配数据，这里的value是你遍历数组每一项的value，如果没有对后台返回的数据做处理，一般为id
            });
            this.baseForm.areaLabel = obj.addressName;
        },
        dwjdValue(value) {
            //   console.log(value);
            this.baseForm.streetCode = value;
            let obj = {};
            obj = this.option14.find(item => {
                //这里的ClaOptions就是上面遍历的数据源
                return item.id === value; //筛选出匹配数据，这里的value是你遍历数组每一项的value，如果没有对后台返回的数据做处理，一般为id
            });
            this.baseForm.streetLabel = obj.addressName;
        },
        async selectDwJd() {
            this.option14 = [];
            let res = await findAddressByParentId({
                id: this.baseForm.areaId
            });
            //   console.log(res);
            this.option14 = this.option14.concat(res.content.list);
        },
        //获取单位地址查询
        async selectDwSheng() {
            this.option11 = [];
            let res = await findAddressByParentId({
                id: "0"
            });
            if (!res.content) return
            this.option11 = this.option11.concat(res.content.list);
        },
        async selectDwShi() {
            this.option12 = [];
            let res = await findAddressByParentId({
                id: "1"
            });
            if (!res.content) return
            //   console.log(res);
            this.option12 = this.option12.concat(res.content.list);
        },
        async selectDwQu() {
            this.option13 = [];
            let res = await findAddressByParentId({
                id: "2"
            });
            if (!res.content) return
            //   console.log(res);
            this.option13 = this.option13.concat(res.content.list);
        }
    }
}